module.exports = __webpack_public_path__ + "static/media/MultiDevices.d17b3bcb.png";